import { render } from "./PreviewImage.vue?vue&type=template&id=a1d0e6fe&ts=true"
import script from "./PreviewImage.vue?vue&type=script&lang=ts"
export * from "./PreviewImage.vue?vue&type=script&lang=ts"

import "./PreviewImage.vue?vue&type=style&index=0&id=a1d0e6fe&lang=scss"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__